// extracted by mini-css-extract-plugin
module.exports = {"underline":"Underline_underline__MncoC","underlineCustom":"Underline_underlineCustom__y_SIu"};